import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'input[upperCase],textarea[upperCase]',
    standalone: false
})
export class UpperCaseDirective {
    @Input() public upperCase: string;

    @HostListener('blur', ['$event.target', '$event.target.value'])
    public onBlur(el: any, value: string): void {
        if ((!this.upperCase || 'blur' === this.upperCase) && 'function' === typeof value.toUpperCase && value.toUpperCase() !== value) {
            this.convertValue(el, value);
            this.dispatchEvent(el, 'blur');
        }
    }

    @HostListener('input', ['$event.target', '$event.target.value'])
    public onInput(el: any, value: string): void {
        if (!this.upperCase && 'function' === typeof value.toUpperCase && value.toUpperCase() !== value) {
            let { start, end } = this.getCaret(el);

            if (value[0] === ' ' && start === 1 && end === 1) {
                start = 0;
                end = 0;
            }

            this.convertValue(el, value);
            this.setCaret(el, start, end);
        }
    }

    private convertValue(el, value): void {
        el.value = value.toUpperCase();
        this.dispatchEvent(el, 'input');
    }

    private dispatchEvent(el, eventType): void {
        const event = document.createEvent('Event');
        event.initEvent(eventType, false, false);
        el.dispatchEvent(event);
    }

    private getCaret(el): any {
        return {
            start: el.selectionStart,
            end: el.selectionEnd
        };
    }

    private setCaret(el, start, end): void {
        el.selectionStart = start;
        el.selectionEnd = end;
        el.focus();
    }
}
